import { schoolConstants } from '../_constants';

//-- add School
export function addSchool(state = {}, action) {
  switch (action.type) {
    case schoolConstants.SCHOOL_ADDED_REQUEST:
      return {
        addSchool: false
      };

    case schoolConstants.SCHOOL_ADDED_SUCCESS:
      //console.log("ASC ", action.user);
      return { addSchool:action.successAction};

    case schoolConstants.SCHOOL_ADDED_FAILURE:
      return {
        addSchool: false,
      };

    default:
      return state
  }
}


//-- get coupons list
export function getSchoolsList(state = {}, action) {
  switch (action.type) {
    case schoolConstants.SCHOOL_LIST_REQUEST:
      return {
        getSchoolsList: false
      };

    case schoolConstants.SCHOOL_LIST_SUCCESS:
      return { getSchoolsList:action.successAction};

    case schoolConstants.SCHOOL_LIST_FAILURE:
      return {
        getSchoolsList: false,
      };

    default:
      return state
  }
}

//-- save the list of Contest
export function saveSchool(state = {}, action) {
  switch (action.type) {
    case schoolConstants.SCHOOL_ADDED_REQUEST:
      return {
        savedSchool: false
      };

    case schoolConstants.SCHOOL_ADDED_SUCCESS:
      //console.log("REDUCER ", action);
      return { savedSchool: action.successAction };

    case schoolConstants.SCHOOL_ADDED_FAILURE:
      return {
        savedSchool: false,
      };

    default:
      return state
  }
}

//-- delete the Contest
export function deleteSchool(state = {}, action) {
  switch (action.type) {
    case schoolConstants.DELETE_SCHOOL_REQUEST:
      return {
        deleteSchool: false
      };

    case schoolConstants.DELETE_SCHOOL_SUCCESS:
      //console.log("REDUCER ", action);
      return { deleteSchool: action.successAction };

    case schoolConstants.DELETE_SCHOOL_FAILURE:
      return {
        deleteSchool: false,
      };

    default:
      return state
  }
}

// Get specific category by id
export function getSchool(state = {}, action) {
  switch (action.type) {
    case schoolConstants.SCHOOL_BY_ID_REQUEST:
      return {
        editSchoolData: false
      };

    case schoolConstants.SCHOOL_BY_ID_SUCCESS:
      //console.log("ASC ", action.user);
      return { editSchoolData:action.successAction};

    case schoolConstants.SCHOOL_BY_ID_FAILURE:
      return {
        editSchoolData: false,
      };

    default:
      return state
  }
}